declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: false;
    sm: false;
    md: false;
    lg: false;
    xl: false;
    mobile: true;
    laptop: true;
  }
}

export const breakpointValues = {
  mobile: 0,
  laptop: 801,
};
